import styled from '@emotion/styled'
import {
  Checkbox,
  FormControl,
  Icon,
  InputLabel,
  MenuItem,
  SelectMultipleProps,
  theme,
} from '@yuno/design-system-web'
import { useContext, useEffect, useState } from 'react'
import { FiltersContext } from '../../context/filters-context'
import { countryNames, MenuProps, textSearch } from '../../utils/constants'
import { useTranslation } from 'react-i18next'

import { filtersLiterals } from './literals'
import {
  AlternativeTextTypoSelect,
  CustomInputCountriesSearch,
  CustomListItemText,
  StyledSelect,
} from './styles'
import { selectRender } from '../../utils/selectRender'

const options = Object.values(filtersLiterals.countryCoverage.optionsLabels)

export const Wrapper = styled.div`
  width: 220px;
  margin-left: 16px;
`

export default function CountryCoverageFilter() {
  const {
    handleSetFilter,
    filter: { countryCoverage },
  } = useContext(FiltersContext)
  const [allOptionsSelected, useAllOptionsSelected] = useState(true)
  const [noneSelected, useNoneSelected] = useState(true)
  const [filteredOptions, setFilteredOptions] = useState(options)
  const { t } = useTranslation()

  const handleChange = (event) => {
    const {
      target: { value },
    } = event
    const isCountriesSearch = value.filter(
      (item) => item === '' || item.includes('countriesSearch'),
    )
    if (isCountriesSearch.length > 0) return
    setFilteredOptions(options)
    useAllOptionsSelected(value?.length === options?.length)
    useNoneSelected(value?.length === 0)

    const countrys = value?.map(
      (item) =>
        Object.entries(countryNames).filter(([key, valueObject]) => {
          if (item === valueObject) {
            return key
          }
        })[0][0],
    )

    handleSetFilter(
      'countryCoverage',
      typeof value === 'string' ? value.split(',') : value,
    )
    handleSetFilter(
      'countryCoverageCode',
      typeof countrys === 'string' ? countrys.split(',') : countrys,
    )
  }

  useEffect(() => {
    useAllOptionsSelected(countryCoverage?.length === options?.length)
    useNoneSelected(countryCoverage?.length === 0)
  }, [])

  const handleCountriesSearchChange = (event) => {
    const {
      target: { value },
    } = event
    if (value === '') setFilteredOptions(options)
    const newOptions = options.filter((option) =>
      textSearch(option).includes(textSearch(value)),
    )
    setFilteredOptions(newOptions)
  }

  const handleRenderValue = (selected: SelectMultipleProps['value']) => {
    return selectRender(selected, options);
  }

  return (
    <Wrapper>
      <InputLabel id="multiple-checkbox-label">
        {t('countryCoverage')}
      </InputLabel>
      <FormControl fullWidth style={{ position: 'relative' }}>
        <StyledSelect
          multiple
          displayEmpty
          value={countryCoverage}
          onChange={handleChange}
          renderValue={handleRenderValue}
          MenuProps={MenuProps}
          IconComponent={(props) => (
            <Icon name="CaretDown" weight="bold" {...props} />
          )}
        >
          <CustomInputCountriesSearch
            nonce='undefined'
            type="text"
            placeholder={t('search')}
            onChange={handleCountriesSearchChange}
            onKeyDownCapture={(e) => {
              if (!(e.code === 'ArrowUp' || e.code === 'ArrowDown')) {
                e.stopPropagation()
              }
            }}
            onFocus={handleCountriesSearchChange}
          />
          {filteredOptions.map((name) => (
            <MenuItem
              style={{
                backgroundColor: theme.palette.neutral.white[0],
                color: theme.palette.neutral.black,
                padding: 0,
              }}
              key={name}
              value={name}
              id={name}
              onKeyDown={(e) => e.stopPropagation()}
            >
              <Checkbox checked={countryCoverage.indexOf(name) > -1} />
              <CustomListItemText primary={name} />
            </MenuItem>
          ))}
        </StyledSelect>
      </FormControl>
    </Wrapper>
  )
}

CountryCoverageFilter.defaultProps = { headerComponent: true }
